"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on 16.10.2018
*/

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../core/conversions/DataObjectConverter");

var AppModule_1 = require("../core/modules/AppModule");

var NotificationDocConverter_1 = require("../notifications/documents/NotificationDocConverter");

var PromotionAppConfigConverter_1 = require("./config/conversions/PromotionAppConfigConverter");

var PromotionAppConfigConverterImpl_1 = require("./config/conversions/PromotionAppConfigConverterImpl");

var ExportedPromotionConverter_1 = require("./conversions/ExportedPromotionConverter");

var ExportedPromotionConverterImpl_1 = require("./conversions/ExportedPromotionConverterImpl");

var ExportedPromotionForecastConverter_1 = require("./conversions/ExportedPromotionForecastConverter");

var ExportedPromotionForecastConverterImpl_1 = require("./conversions/ExportedPromotionForecastConverterImpl");

var ExportedPromotionPerformanceConverter_1 = require("./conversions/ExportedPromotionPerformanceConverter");

var ExportedPromotionPerformanceConverterImpl_1 = require("./conversions/ExportedPromotionPerformanceConverterImpl");

var ManualPromoWeekSplitConverter_1 = require("./conversions/ManualPromoWeekSplitConverter");

var ManualPromoWeekSplitConverterImpl_1 = require("./conversions/ManualPromoWeekSplitConverterImpl");

var MasterAreaDeactivatedNotificationConverterImpl_1 = require("./conversions/notifications/MasterAreaDeactivatedNotificationConverterImpl");

var PreExportedPromotionForecastConverter_1 = require("./conversions/PreExportedPromotionForecastConverter");

var PreExportedPromotionForecastConverterImpl_1 = require("./conversions/PreExportedPromotionForecastConverterImpl");

var PromotionActionContextConverter_1 = require("./conversions/PromotionActionContextConverter");

var PromotionActionContextConverterImpl_1 = require("./conversions/PromotionActionContextConverterImpl");

var PromotionAreaBindingConverter_1 = require("./conversions/PromotionAreaBindingConverter");

var PromotionAreaBindingConverterImpl_1 = require("./conversions/PromotionAreaBindingConverterImpl");

var PromotionAreaConverter_1 = require("./conversions/PromotionAreaConverter");

var PromotionAreaConverterImpl_1 = require("./conversions/PromotionAreaConverterImpl");

var PromotionConverter_1 = require("./conversions/PromotionConverter");

var PromotionConverterImpl_1 = require("./conversions/PromotionConverterImpl");

var PromotionFilterConverter_1 = require("./conversions/PromotionFilterConverter");

var PromotionFilterConverterImpl_1 = require("./conversions/PromotionFilterConverterImpl");

var PromotionOverviewFilterConverter_1 = require("./conversions/PromotionOverviewFilterConverter");

var PromotionOverviewFilterConverterImpl_1 = require("./conversions/PromotionOverviewFilterConverterImpl");

var PromotionProductConverter_1 = require("./conversions/PromotionProductConverter");

var PromotionProductConverterImpl_1 = require("./conversions/PromotionProductConverterImpl");

var PromotionSimulationConverter_1 = require("./conversions/PromotionSimulationConverter");

var PromotionSimulationConverterImpl_1 = require("./conversions/PromotionSimulationConverterImpl");

var PromotionSplitDTOConverter_1 = require("./conversions/PromotionSplitDTOConverter");

var PromotionSplitDTOConverterImpl_1 = require("./conversions/PromotionSplitDTOConverterImpl");

var PromotionStatusConverter_1 = require("./conversions/PromotionStatusConverter");

var PromotionStatusConverterImpl_1 = require("./conversions/PromotionStatusConverterImpl");

var PromotionTypeConverter_1 = require("./conversions/PromotionTypeConverter");

var PromotionTypeConverterImpl_1 = require("./conversions/PromotionTypeConverterImpl");

var Promotion_1 = require("./model/Promotion");
/**
 * @author MSu
 */


var PromotionAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(PromotionAppModule, _AppModule_1$AppModul);

  function PromotionAppModule() {
    var _this;

    _classCallCheck(this, PromotionAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'promotion';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromotionAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(PromotionOverviewFilterConverter_1.PromotionOverviewFilterConverter).to(PromotionOverviewFilterConverterImpl_1.PromotionOverviewFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(DataObjectConverter_1.DataObjectConverter, {
        className: Promotion_1.Promotion.name
      }).to(PromotionConverterImpl_1.PromotionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ManualPromoWeekSplitConverter_1.ManualPromoWeekSplitConverter).to(ManualPromoWeekSplitConverterImpl_1.ManualPromoWeekSplitConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionConverter_1.PromotionConverter).to(PromotionConverterImpl_1.PromotionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionProductConverter_1.PromotionProductConverter).to(PromotionProductConverterImpl_1.PromotionProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionTypeConverter_1.PromotionTypeConverter).to(PromotionTypeConverterImpl_1.PromotionTypeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionActionContextConverter_1.PromotionActionContextConverter).to(PromotionActionContextConverterImpl_1.PromotionActionContextConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionStatusConverter_1.PromotionStatusConverter).to(PromotionStatusConverterImpl_1.PromotionStatusConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionFilterConverter_1.PromotionFilterConverter).to(PromotionFilterConverterImpl_1.PromotionFilterConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedPromotionConverter_1.ExportedPromotionConverter).to(ExportedPromotionConverterImpl_1.ExportedPromotionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedPromotionPerformanceConverter_1.ExportedPromotionPerformanceConverter).to(ExportedPromotionPerformanceConverterImpl_1.ExportedPromotionPerformanceConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionAreaConverter_1.PromotionAreaConverter).to(PromotionAreaConverterImpl_1.PromotionAreaConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionAreaBindingConverter_1.PromotionAreaBindingConverter).to(PromotionAreaBindingConverterImpl_1.PromotionAreaBindingConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, MasterAreaDeactivatedNotificationConverterImpl_1.MasterAreaDeactivatedNotificationConverterImpl.QUALIFIER).to(MasterAreaDeactivatedNotificationConverterImpl_1.MasterAreaDeactivatedNotificationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionSimulationConverter_1.PromotionSimulationConverter).to(PromotionSimulationConverterImpl_1.PromotionSimulationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ExportedPromotionForecastConverter_1.ExportedPromotionForecastConverter).to(ExportedPromotionForecastConverterImpl_1.ExportedPromotionForecastConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PreExportedPromotionForecastConverter_1.PreExportedPromotionForecastConverter).to(PreExportedPromotionForecastConverterImpl_1.PreExportedPromotionForecastConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionSplitDTOConverter_1.PromotionSplitDTOConverter).to(PromotionSplitDTOConverterImpl_1.PromotionSplitDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(PromotionAppConfigConverter_1.PromotionAppConfigConverter).to(PromotionAppConfigConverterImpl_1.PromotionAppConfigConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return PromotionAppModule;
}(AppModule_1.AppModule);

exports.PromotionAppModule = PromotionAppModule;